export class BaseStore {
    executeRecaptcha = (action: (token: string) => void) => {
        grecaptcha.ready(() => {
            grecaptcha.execute("6LfTcPYoAAAAAFvlHS-goH_RZQLLCaI70WJDB4pX", {action: 'submit'}).then(async (token) => {
                action(token);
            });
        });
    }
}
